import React from "react";
import ReactDOM from "react-dom/client";
// the app's ONE typeface is GOOGLE SANS (user call 2026-10-16: "change the
// font in the whole app to Google Sans"; Calibri, shipped as Carlito,
// 2026-09-13 → 2026-10-16) — the real family, SIL OFL since Google opened
// it, self-hosted from @fontsource/google-sans: THREE upright cuts,
// Regular / Medium / Bold and NO SemiBold, so CSS weight matching draws
// the ladder's 500 as Medium and 600 / 700 both as Bold — the 600 file
// made 500 Medium and 600 SemiBold near-twins and the app's emphasis
// vanished ("Built for <name>" read as one weight; user call the same
// hour: "fix bolding usage here"), and dropping to Regular + Bold alone
// thinned the Weekly cards' questions ("titles of proposed labs should
// stay bolder"); the @font-face rules come from the package,
// `--font-sans` in index.css names the family (see the token's note)
import "@fontsource/google-sans/400.css";
import "@fontsource/google-sans/500.css";
import "@fontsource/google-sans/700.css";
// (the wordmark's Lato Light — the third face, 2026-09-13 → 2026-09-28 —
// went when the mark became an IMAGE, public/logo_round.png; see
// components/Wordmark)
// the list rows' BRAND NAMES (user call 2026-09-15: "use Roboto on them
// and make them a bit larger"): Roboto Medium, the third face; `--font-row`
// in index.css names it
import "@fontsource/roboto/500.css";
// the lists' TITLE face — IMPACT (user call 2026-09-19: "Top 100" in
// Impact, "make sure it is Impact"; the title alone since the same hour).
// Impact itself cannot be shipped (Microsoft's; on Windows, Mac and iOS,
// never Android), so `--font-display` names it first and Anton — its
// open-licence twin, the same compressed poster grotesque — is the cut an
// Android phone draws; the fourth face
import "@fontsource/anton/400.css";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
